import {Component, Input, OnInit} from '@angular/core';
import {TrackingResponse} from "../../entities";

const CARRIER_NAMES: Record<string, string> = {
  MAEU: 'Maersk',
  MSCU: 'MSC',
  CMAU: 'CMA CGM',
  ONEY: 'ONE Line',
  YMLU: 'Yang Ming',
  OOLU: 'OOCL',
  COSU: 'COSCO',
  ZIMU: 'ZIM',
  HLCU: 'Hapag-Lloyd',
  HDMU: 'HMM',
  EGLV: 'Evergreen',
};

@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
    standalone: false
})
export class SummaryComponent implements OnInit {

  @Input()
  trackingResponse!: TrackingResponse;

  scacCode = '';
  carrierName = '';
  hasLogo = false;

  constructor() {
  }

  ngOnInit(): void {
    const first: any = this.trackingResponse?.results?.[0];
    this.scacCode = (first?.scacCode || '').toUpperCase();
    this.carrierName = CARRIER_NAMES[this.scacCode] || this.scacCode;
    this.hasLogo = this.scacCode in CARRIER_NAMES;
  }

  get logoPath(): string {
    return `assets/carriers_logo/${this.scacCode}.png`;
  }
}
